import React from 'react'

export default function GridHeader({teamLogo, teamName, sportName}) {
  return (
    <div className='flex items-center p-4 bg-white shadow-md rounded-t-lg'>
        <img src={teamLogo} height={60} width={60} alt="LOGO" className='rounded-full mr-4' />
        <div>
            <h1 className='text-lg font-bold'>{teamName}</h1>
            <p className='text-gray-500 text-sm'>{sportName}</p>
        </div>
    </div>
  )
}
